<template>
  <section id="layout_0_footer_0_Msg_Wrap" class="c-privacy">
    <div class="l-wrap">
      <div class="c-privacy__container">
        <div class="c-privacy__main">
          為提供您最佳個人化且即時的服務，本網站透過使用Cookies記錄與存取您的瀏覽使用訊息。當您使用本網站，即表示您同意Cookies技術支援。（更多資訊請參閱
          <a
            href="https://www.cathaylife.com.tw/cathaylife/about/info/info-security/privacy"
            id="link_1560333218156"
            style="color: yellow"
          >
            隱私權保護政策
          </a>
          ，如需修改Cookie設定請參閱第四點、第九點）
        </div>
        <div class="c-privacy__action">
          <a
            href="#"
            id="privacy"
            class="o-btn o-btn--primary"
            data-id="privacy"
            @click.stop.prevent="checkCookie"
          >
            接受
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "privacy",
  data() {
    return {};
  },
  mounted() {
    if ("Y" === Cookies.get("OI_Privacy_CHECK")) {
      $(".c-privacy").addClass("is-hidden");
    }
  },
  methods: {
    checkCookie() {
      $(".c-privacy").addClass("is-hidden");
      Cookies.set("OI_Privacy_CHECK", "Y", {
        expires: 3650,
        domain: ".cathaylife.com.tw",
        path: "/",
      });
    },
  },
};
</script>

<style scoped>
.c-privacy {
  padding: 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 9999;
  -webkit-transition: height 0.3s;
  -o-transition: height 0.3s;
  transition: height 0.3s;
  font-family: Arial, "Microsoft JhengHei", Helvetica, sans-serif;
}
.c-privacy.is-hidden {
  display: none;
}
.c-privacy:before {
  content: "";
  width: 100%;
  background-color: #000;
  opacity: 0.7;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
}
.c-privacy__container {
  height: 100%;
}
.c-privacy__main {
  font-size: 14px;
  color: #fff;
}
.c-privacy__action {
  margin-top: 15px;
  text-align: center;
}
@media only screen and (min-width: 768px) {
  .c-privacy__container {
    display: table;
    width: 100%;
  }
  .c-privacy__main {
    display: table-cell;
    width: 635px;
  }
  .c-privacy__action {
    display: table-cell;
    vertical-align: middle;
    text-align: right;
  }
}

.l-wrap__login {
  max-width: 520px;
  margin: 0 auto;
}
.l-wrap:before {
  content: "";
  display: table;
}
@media only screen and (max-width: 1023px) {
  .l-wrap\@t {
    padding: 0 15px 0 15px;
  }
}
@media only screen and (min-width: 1024px) {
  .l-wrap {
    max-width: 1000px;
    margin: 0 auto;
  }
  .l-wrap__iframe {
    max-width: 1024px;
  }
}
.o-btn {
  font-family: Arial, "Microsoft JhengHei", Helvetica, sans-serif;
  display: inline-block;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  padding: 10px 30px;
  color: #ff7b00;
  background-color: #fff;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  border: 1px solid #ff7b00;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 80%;
  text-align: center;
  outline: 0;
  cursor: pointer;
  position: relative;
  z-index: 1;
}
.o-btn:hover {
  color: #ff9113;
  border-color: #ff9113;
}
.o-btn--noBorder {
  border: 0;
}
.o-btn--m {
  font-size: 16px;
  padding: 5px 20px;
}
.o-btn--primary {
  color: #fff;
  background-color: #ff7b00;
}
.o-btn--primary:hover {
  color: #fff;
  background-color: #ff9113;
  border-color: #ff9113;
}
.o-btn--transparent {
  background-color: transparent;
}
.o-btn--white {
  color: #fff;
  border: 1px solid #fff;
  background-color: transparent;
}
.o-btn--white:hover {
  color: #fff;
  border: 1px solid #fff;
}
.o-btn.is-disabled,
.o-btn[disabled] {
  color: #fff;
  background-color: #929292;
  border: 1px solid #929292;
  pointer-events: none;
  cursor: default;
}
.o-btn--normal {
  width: auto;
}
.o-btn--full {
  width: 100%;
}
.o-btn--grid {
  width: 100%;
  max-width: 180px;
  padding-left: 15px;
  padding-right: 15px;
}
@media only screen and (min-width: 768px) {
  .o-btn {
    width: auto;
  }
  .o-btn--full {
    width: auto;
  }
  .o-btn--grid {
    width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .o-btn--percent\@t {
    width: 80%;
  }
}
</style>
